import common from './common';
import { Group, Vector3, DirectionalLight } from 'three';

export default class SplashGlobe extends Group {
	constructor() {
		super();

		this._globeDisabled = false;
		this._globe = null;
		this._directionalLight = null;

		this.init();
	}

	init() {
		this._globe = common.AssetManager.model('earth_globe');
		this._globe.rotateOnAxis(new Vector3(1, 0, 1).normalize(), 0.4101524);
		this._globe.rotateY(Math.PI);
		this.add(this._globe);

		this._directionalLight = new DirectionalLight(0xFFFFFF, 4);
		this._directionalLight.position.set(10, 10, 10);
		this._directionalLight.lookAt(0, 0, 0);

		common.tScene.add(this._directionalLight);
	}

	destroy() {
		common.tScene.remove(this._directionalLight);

		this._globe.geometry.dispose();
		this._globe.material.dispose();
		this.parent.remove(this);
	}

	update() {
		if (common.motion) {
			this._globe.rotateY(0.0005);
		}
	}

	get globeDisabled() {
		return this._globeDisabled;
	}

	set globeDisabled(v) {
		this._globeDisabled = v;
	}
}
